import { Box, Grid } from "@mui/material";
import { KeyDriveBodyMax } from "../../../../../components/KeydriveComponents/Fonts/Body/KeyDriveBodyMax";
import KeyDriveCheckbox from "../../../../../components/KeydriveComponents/Checkbox/KeyDriveCheckbox";
import { KeyDriveBodyMin } from "../../../../../components/KeydriveComponents/Fonts/Body/KeyDriveBodyMin";
import { useTranslation } from "react-i18next";

interface IEditFolderNoitifications {
    setSelectNotification: (set: boolean) => void;
    selectNotification: boolean;
}

function EditFolderNotifications({
    setSelectNotification,
    selectNotification
}: IEditFolderNoitifications) {
    const { t } = useTranslation();
    
    return (
        <>
            <Grid item xs={12} mt="30px">
                <KeyDriveBodyMax
                    color='#2D2D2D'
                    needBold
                    needEllipses={false}
                    text={t('EditFolder.notifications')}
                />
            </Grid>
            <Grid item xs={12} mt="10px">
                <Box
                    width="100%"
                    height="36px"
                    border="1px solid #E9EFF4"
                    borderRadius="4px"
                    padding="8px"
                    display="flex"
                >
                    <KeyDriveCheckbox 
                        onChange={(e) => {
                            if (e.target.checked) {
                                setSelectNotification(true);
                            } else {
                                setSelectNotification(false);
                            }
                        }}
                        value={selectNotification}
                        checked={selectNotification}
                    />
                    <KeyDriveBodyMin
                        color='#2D2D2D'
                        needBold
                        needEllipses={false}
                        text={t('EditFolder.receiveEmailNotifications')}
                    />
                </Box>
            </Grid>
        </>
    );
}

export default EditFolderNotifications;